module.exports = __webpack_public_path__ + "img/martial-arts-technology.3769e49e.svg";